<template>
  <v-app>
    <v-container
        class="fill-height"
        fluid
    >
      <v-row
          align="center"
          justify="center"
          class="pure-hero-bg py-10"
      >
        <v-col
            cols="12"
            sm="8"
            md="4"
        >
          <h1 class="hero-title mt-0">
            Welcome back, Hero.
          </h1>
          <p class="hero-paragraph">
            Please Login Below
          </p>
          <v-form>
            <v-text-field
                v-model="user.email"
                label="E-Mail"
                prepend-inner-icon="fas fa-user"
                required></v-text-field>
            <v-text-field
                v-model="user.password"
                label="Password"
                prepend-inner-icon="fas fa-lock"
                type="password"
                required></v-text-field>
            <div>
            <button class="button button-shadow button-primary button-glow"
                    @click.prevent="login">
              Login
            </button>
            </div>
          </v-form>
          <transition name="fade">
            <p
                v-if="error"
                class="error&#45;&#45;text mt-24">
              Whoops! Something went wrong - {{ error }}
            </p>
          </transition>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "LoginHeader",
  data() {
    return {
      auth: '',
      user: {
        email: '',
        password: ''
      },
      error: ''
    }
  },
  methods: {
    async login() {
      this.error = ''

      await this.auth.signInWithEmailAndPassword(this.user.email, this.user.password)
          .then(
              res => {
                console.log(res)
                this.$user = this.auth.currentUser
                this.$router.push('/dashboard')
              }
          )
          .catch(err => {
            console.error(err)
            switch (err.code) {
              case "auth/user-not-found":
                this.error = "Your details are invalid. Please check and try again"
                break;
              default:
                this.error = err.message
            }
          })
    }
  },
  mounted() {
    this.error = ''
    this.auth = this.$firebase.auth();
  }
}
</script>

<style scoped>

</style>
